<template>
  <div class="diferenciais" v-if="differentials.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="ui-subtitle--interna">
            <h2>
              Diferenciais do Empreendimento
            </h2>
          </div>
        </div>
        <div class="col-12">
          <carousel
          v-if="differentials.length > 0"
          :per-page="1"
          :paginationPadding="5"
          :paginationSize="15"
          :paginationActiveColor="'#13182c'"
          :perPageCustom="[[480, 1], [768, 3], [1024, 4]]"
          :loop="false"
          :autoplay="false">
            <slide v-for="(item,index) in differentials" :key="index">
              <div class="diferenciais__itens">
                <div class="diferenciais__box" :class="{'active' : index == tabOne}" @click="aciveTab(index)">
                  <img v-if="item.image" :src="item.image" :alt="item.title"> {{item.title}}
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <div class="col-12">
          <div class="diferenciais__tab" v-for="(item,index) in differentials" :key="index" v-show="index == tabOne" v-html="item.description">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  props: ['differentials'],
  data () {
    return {
      tabOne: 0
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    aciveTab (a) {
      this.tabOne = a
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.diferenciais {
  background: $bgIntern;
  padding-bottom: 80px;
  &__itens {
    padding: 0 10px;
  }
  &__box {
    background: white;
    border-radius: 5px;
    border: 1px $effect solid;
    color: $text;
    cursor: pointer;
    font-size: 16px;
    padding: 10px 40px;
    overflow: hidden;
    position: relative;
    text-align: center;
    width: 100%;
    img {
      margin-right: 5px;
    }
  }
  .active {
    background: $primary;
    border: none;
    color: white;
    &:before {
      background: $green;
      bottom: 0;
      content: '';
      height: 5px;
      left: 0;
      position: absolute;
      width: 100%;
    }
    img {
      filter: grayscale(100%) brightness(200%);
    }
  }
  &__tab {
    margin-top: 40px;
  }
  @media (max-width: 1200px) {
    padding-bottom: 60px;
    &__tab {
      margin-top: 30px;
    }
    &__box {
      img {
        margin-bottom: 5px;
      }
    }
  }
  @media (max-width: 991px) {
    padding-bottom: 40px;
    &__tab {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaApresentacaoDiferenciais.vue